import { ref } from 'vue';
import { IssueQuery } from '@/services/api/resources/issue/v2/query';
import { useTask } from '@/ui/concerns';
import { list as getIssueList } from '@/services/api/resources/todo';
import { sequence } from '@/ui/helpers';

export const useIssueCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const issueQuery = (): IssueQuery => ({
    page: 1,
    perPage: 1,
    sort: '',
    dir: '',
    search: '',
    assignee: [],
    entityItem: [],
    status: [],
    issueStatus: [],
    priority: [],
    updatedAtStart: null,
    updatedAtEnd: null,
    overdue: null,
  });

  const performCheck = useTask(
    () => sequence(
      getIssueList(issueQuery()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
